module.exports = __webpack_public_path__ + "img/icon_map_36_on_111.cc18224b.png";